export default __webpack_public_path__ + "static/media/white-okta-logo.dd154808.png";